(() => {
  const SELECTOR = '.innon-purchase-top-layout';

  function initialiseProductLayout(root = document) {
    const articles = root.querySelectorAll(SELECTOR);

    articles.forEach((article) => {
      const main = article.querySelector(':scope > .product-main');

      if (!main) {
        return;
      }

      const details = main.querySelector('.product-details');

      if (!details) {
        return;
      }

      /*
       * Only the Description block becomes full width.
       *
       * All other product blocks remain inside the normal
       * product-details column, including Resourcehub
       * Downloads, regardless of whether they appear before
       * or after the Form block.
       */
      const descriptionBlock = article.querySelector(
        '.product-block--description'
      );

      if (!descriptionBlock) {
        return;
      }

      let wide = article.querySelector(
        ':scope > .innon-product-wide-content'
      );

      if (!wide) {
        wide = document.createElement('div');
        wide.className = 'innon-product-wide-content';
        wide.setAttribute(
          'data-innon-product-wide-content',
          ''
        );

        main.insertAdjacentElement(
          'afterend',
          wide
        );
      }

      if (
        descriptionBlock.parentElement !== wide
      ) {
        wide.appendChild(descriptionBlock);
      }
    });
  }

  function start() {
    initialiseProductLayout(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseProductLayout(event.target);
    }
  );
})();


/* =========================================================
   INNON STICKY PURCHASE V1
   purchase-top only

   No duplicate Shopify product form is created.
   This panel proxies the existing quantity, ATC and
   Shopify dynamic checkout controls.
   ========================================================= */

(() => {
  const LAYOUT_SELECTOR = '.innon-purchase-top-layout';
  const MIN_WIDTH = 1024;

  function visibleHeaderBottom() {
    const selectors = [
      '.site-header',
      '.site-header-main',
    ];

    let bottom = 0;

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        const style = getComputedStyle(el);

        if (
          style.display === 'none' ||
          style.visibility === 'hidden'
        ) {
          return;
        }

        const rect = el.getBoundingClientRect();

        if (
          rect.bottom > 0 &&
          rect.top < window.innerHeight
        ) {
          bottom = Math.max(bottom, rect.bottom);
        }
      });
    });

    return Math.max(16, bottom + 12);
  }

  function copyButtonStyle(source, target) {
    if (!source || !target) {
      return;
    }

    const style = getComputedStyle(source);

    [
      'backgroundColor',
      'color',
      'borderColor',
      'borderStyle',
      'borderWidth',
      'borderRadius',
      'fontFamily',
      'fontSize',
      'fontWeight',
      'letterSpacing',
      'textTransform',
    ].forEach((property) => {
      target.style[property] = style[property];
    });
  }

  function setupStickyPurchase(layout) {
    if (
      layout.dataset.innonStickyPurchaseReady === 'true'
    ) {
      return;
    }

    const formBlock = layout.querySelector(
      '.product-block--form'
    );

    if (!formBlock) {
      return;
    }

    const actionWrapper = formBlock.querySelector(
      '.product-form__action-wrapper'
    );

    const realAtc = formBlock.querySelector(
      '[data-product-atc]'
    );

    const realQuantity = formBlock.querySelector(
      '[data-quantity-input]'
    );

    const realMinus = formBlock.querySelector(
      '[data-quantity-minus]'
    );

    const realPlus = formBlock.querySelector(
      '[data-quantity-plus]'
    );

    if (
      !actionWrapper ||
      !realAtc ||
      !realQuantity
    ) {
      return;
    }

    const titleSource = layout.querySelector(
      '.product-title'
    );

    const priceSource = layout.querySelector(
      '[data-product-pricing]'
    );

    const getPaymentButton = () => (
      formBlock.querySelector(
        '.shopify-payment-button__button'
      )
      ||
      formBlock.querySelector(
        '.shopify-payment-button button'
      )
    );

    const panel = document.createElement('aside');

    panel.className = 'innon-sticky-purchase';

    panel.setAttribute(
      'data-innon-sticky-purchase',
      ''
    );

    panel.setAttribute(
      'aria-hidden',
      'true'
    );

    panel.innerHTML = `
      <div class="innon-sticky-purchase__summary">
        <strong
          class="innon-sticky-purchase__title"
          data-insp-title
        ></strong>

        <span
          class="innon-sticky-purchase__price"
          data-insp-price
        ></span>
      </div>

      <div class="innon-sticky-purchase__controls">
        <div class="innon-sticky-purchase__quantity">
          <button
            type="button"
            data-insp-minus
            aria-label="Decrease quantity"
          >−</button>

          <input
            type="number"
            min="1"
            step="1"
            data-insp-quantity
            aria-label="Quantity"
          >

          <button
            type="button"
            data-insp-plus
            aria-label="Increase quantity"
          >+</button>
        </div>

        <button
          type="button"
          class="innon-sticky-purchase__atc"
          data-insp-atc
        >
          Add to cart
        </button>

        <button
          type="button"
          class="innon-sticky-purchase__buy"
          data-insp-buy
        >
          Buy it now
        </button>
      </div>
    `;

    /*
     * Keep the sticky panel inside Product Information.
     * This means purchase-top section Custom CSS can
     * still be used for rapid visual tweaks.
     */
    layout.appendChild(panel);

    const title = panel.querySelector(
      '[data-insp-title]'
    );

    const price = panel.querySelector(
      '[data-insp-price]'
    );

    const quantity = panel.querySelector(
      '[data-insp-quantity]'
    );

    const minus = panel.querySelector(
      '[data-insp-minus]'
    );

    const plus = panel.querySelector(
      '[data-insp-plus]'
    );

    const atc = panel.querySelector(
      '[data-insp-atc]'
    );

    const buy = panel.querySelector(
      '[data-insp-buy]'
    );

    function sync() {
      if (titleSource) {
        title.textContent =
          titleSource.textContent
            .replace(/\s+/g, ' ')
            .trim();
      }

      if (priceSource) {
        const visiblePrice =
          priceSource.querySelector(
            '.money:not([style*="display: none"])'
          );

        price.textContent = (
          visiblePrice
            ? visiblePrice.textContent
            : priceSource.textContent
        )
          .replace(/\s+/g, ' ')
          .trim();
      }

      quantity.value = realQuantity.value;

      quantity.min =
        realQuantity.min || '1';

      quantity.step =
        realQuantity.step || '1';

      const atcText = realAtc.querySelector(
        '.atc-button--text'
      );

      atc.textContent = (
        atcText
          ? atcText.textContent
          : realAtc.textContent
      )
        .replace(/\s+/g, ' ')
        .trim();

      atc.disabled = realAtc.disabled;

      copyButtonStyle(realAtc, atc);

      const paymentButton =
        getPaymentButton();

      if (paymentButton) {
        buy.hidden = false;
        buy.disabled =
          Boolean(paymentButton.disabled);

        const paymentText =
          paymentButton.textContent
            .replace(/\s+/g, ' ')
            .trim();

        buy.textContent =
          paymentText || 'Buy it now';

        copyButtonStyle(
          paymentButton,
          buy
        );
      } else {
        buy.hidden = true;
      }
    }

    function sendQuantityEvents() {
      realQuantity.dispatchEvent(
        new Event('input', {
          bubbles: true,
        })
      );

      realQuantity.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );
    }

    minus.addEventListener(
      'click',
      () => {
        if (realMinus) {
          realMinus.click();
        } else {
          realQuantity.stepDown();
          sendQuantityEvents();
        }

        requestAnimationFrame(sync);
      }
    );

    plus.addEventListener(
      'click',
      () => {
        if (realPlus) {
          realPlus.click();
        } else {
          realQuantity.stepUp();
          sendQuantityEvents();
        }

        requestAnimationFrame(sync);
      }
    );

    quantity.addEventListener(
      'change',
      () => {
        const value = Math.max(
          1,
          parseInt(quantity.value, 10) || 1
        );

        realQuantity.value = String(value);

        sendQuantityEvents();
        sync();
      }
    );

    atc.addEventListener(
      'click',
      () => {
        if (!realAtc.disabled) {
          realAtc.click();
        }
      }
    );

    buy.addEventListener(
      'click',
      () => {
        const paymentButton =
          getPaymentButton();

        if (
          paymentButton &&
          !paymentButton.disabled
        ) {
          paymentButton.click();
        }
      }
    );

    realQuantity.addEventListener(
      'input',
      sync
    );

    realQuantity.addEventListener(
      'change',
      sync
    );

    const mutationObserver =
      new MutationObserver(sync);

    mutationObserver.observe(
      formBlock,
      {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          'disabled',
          'class',
          'style',
        ],
      }
    );

    if (priceSource) {
      mutationObserver.observe(
        priceSource,
        {
          subtree: true,
          childList: true,
          characterData: true,
        }
      );
    }

    let scheduled = false;

    function updateVisibility() {
      scheduled = false;

      if (
        window.innerWidth < MIN_WIDTH
      ) {
        panel.classList.remove(
          'innon-sticky-purchase--visible'
        );

        panel.setAttribute(
          'aria-hidden',
          'true'
        );

        return;
      }

      const top = visibleHeaderBottom();

      panel.style.setProperty(
        '--innon-sticky-top',
        `${top}px`
      );

      const purchaseRect =
        actionWrapper.getBoundingClientRect();

      const layoutRect =
        layout.getBoundingClientRect();

      const panelHeight =
        panel.offsetHeight || 160;

      const purchaseHasScrolledAway =
        purchaseRect.bottom < top;

      const productStillOnScreen =
        layoutRect.bottom >
        top + panelHeight + 24;

      const show =
        purchaseHasScrolledAway &&
        productStillOnScreen;

      panel.classList.toggle(
        'innon-sticky-purchase--visible',
        show
      );

      panel.setAttribute(
        'aria-hidden',
        show ? 'false' : 'true'
      );

      if (show) {
        sync();
      }
    }

    function scheduleVisibility() {
      if (scheduled) {
        return;
      }

      scheduled = true;

      requestAnimationFrame(
        updateVisibility
      );
    }

    window.addEventListener(
      'scroll',
      scheduleVisibility,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      scheduleVisibility
    );

    sync();
    updateVisibility();

    layout.dataset.innonStickyPurchaseReady =
      'true';
  }

  function initialise(root = document) {
    if (
      root instanceof Element &&
      root.matches(LAYOUT_SELECTOR)
    ) {
      setupStickyPurchase(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(
        LAYOUT_SELECTOR
      ).forEach(
        setupStickyPurchase
      );
    }
  }

  function start() {
    initialise(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialise(event.target);
    }
  );
})();
